module.exports = __webpack_public_path__ + "img/gomb-ref-aktiv.c6cf2c60.png";